import PropTypes from 'prop-types';
import React from 'react';

const Degree = ({ name, date }) => {
	if (!name && !date) {
		return null;
	}

	const separator = name && date ? ' - ' : '';

	return (
		<li>
			{name}
			{separator}
			{date}
		</li>
	);
};

Degree.propTypes = {
	name: PropTypes.string,
	date: PropTypes.string,
};

Degree.defaultProps = {
	name: null,
	date: null,
};

export default Degree;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/degree.js